import { render, staticRenderFns } from "./agreedHome.vue?vue&type=template&id=3966d546"
import script from "./agreedHome.vue?vue&type=script&lang=js"
export * from "./agreedHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports